var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TemplatesCategoryPage',{attrs:{"categories-story-path":"asiakirjamallit","meta-fallback-description":"Jopa yli 1 000 euron arvoiset sopimukset pikavalinnoin 10 minuutissa kaikkiin elämän ja yritystoiminnan tilanteisiin."}})}
var staticRenderFns = []

export { render, staticRenderFns }